<template>
    <div>
        <!-- Anexar Laudo Externo -->
        <div class="modal fade" id="crmAnexarLaudoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Anexar Laudo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="dados">
                        <div class="alert alert-info">
                            <div class="lead">{{ dados.paciente.st_nome }}</div>
                            <div>#{{ dados.id_atendimento }}</div>
                        </div>

                        <table class="table table-sm table-hover" v-if="laudos && laudos.lista && laudos.lista.length">
                            <thead>
                                <tr>
                                    <th>Procedimento</th>
                                    <th>Profissional</th>
                                    <th>Status</th>
                                    <th>Anexos</th>
                                    <th>Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in laudos.lista" :key="index">
                                    <td><span v-if="item.procedimento">{{ item.procedimento.search }}</span></td>
                                    <td><span v-if="item.atendimento && item.atendimento.medico">{{ item.atendimento.medico.search }}</span></td>
                                    <td><span v-if="item.laudo && item.laudo.status_laudo">{{ item.laudo.status_laudo.search }}</span></td>
                                    <td>
                                        <span v-if="item.laudo && item.laudo.arquivos" class="badge badge-secondary">
                                            {{ item.laudo.arquivos.length }}
                                        </span>
                                    </td>
                                    <td>
                                        <a href="#" @click.prevent="anexar_arquivo(item.laudo)" class="card-link" title="Anexar Laudo Externo">
                                            Anexar
                                        </a>
                                    </td>
                                </tr>   
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="acao_anexar && item_arq">
            <az-file-upload
                extensions="pdf"     
                ref="upload"
                @refresh="refresh_arquivos()" 
                :multiple="true"
                :arquivos="item_arq.arquivos"
                :parms="{ 
                    model_type: 'laudo', 
                    model_id: item_arq.id_laudo, 
                    tipo_especial: 'laudo', 
                    fechar_ao_enviar: true,
                    atualizar_status_laudo: true,
                }" />
        </template>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzFileUpload from '../../util/AzFileUpload.vue';

export default {
    data() {
        return { 
            dados: null, 
            laudos: null, 
            acao_anexar: false, 
            item_arq: null, 
        }
    },

    components: { 
        AzFileUpload
    },

    methods: { 
        refresh_arquivos () { 
            this.$store.commit('loading', false);
        },

        anexar_arquivo (laudo) { 
            $('#crmAnexarLaudoModal').modal('hide');

            this.item_arq = _.cloneDeep(laudo);
            this.acao_anexar = true;

            this.$nextTick(() => { 
                this.$refs.upload.abrir();
            });
        },

        abrir(item, id_fila_lead) { 
            this.acao_anexar = false;

            this.dados = _.cloneDeep(item);
            this.laudos = null; 

            if ( !item.id_atendimento ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Atendimento não identificado.",
                    life: 3000
                });
                return; 
            }

            this.$util.load(this, { 
                service: 'crm',
                func: 'get_exames', 
                parms: { 
                    id_fila_lead: id_fila_lead,
                    id_atendimento: item.id_atendimento,
                },
                loadTo: res => { 
                    this.laudos = res;
                }
            });

            $('#crmAnexarLaudoModal').modal('show');
        }
    }
}
</script>
